import { createServerFn } from "@tanstack/react-start";
import { assignExperiment } from "@wags/experiments";
import { resolveViewerProfileIdentity } from "@/lib/core/auth";
import { markerForArm, type PreviewSplitArm } from "./preview-split-marker.ts";

export const loadPreviewSplit = createServerFn({ method: "GET" }).handler(
    async () => {
        const viewer = await resolveViewerProfileIdentity();
        if (!viewer) {
            throw new Error("Viewer identity is required");
        }
        const assigned = await assignExperiment({
            name: "preview-split",
            subjectId: viewer.appUserId,
        });
        const arm = assigned.arm;
        if (arm !== "control" && arm !== "treatment") {
            throw new Error(`Unexpected preview-split arm ${arm}`);
        }
        return {
            arm: markerForArm(arm as PreviewSplitArm).arm,
            profileId: viewer.appUserId,
        };
    },
);
